export type AggregationMode = "none" | "daily" | "weekly" | "monthly";

export type PresetName = "default" | "availability" | "performance-ratio" | "gen-vs-forecast" | "demand-vs-forecast";

export type Formatters = {
  toLocaleString: (utcTimestamp: string | number) => string;
  toDateTimeString: (utcTimestamp: string | number) => string;
  toDateString: (utcTimestamp: string | number) => string;
  shiftToSiteTimezone: (utcTimestamp: string | number) => number;
  dateRangeToTimestamps: (
    startDate: string,
    endDate: string
  ) => { startMs: number; endMs: number };
  getTime: (utcTimestamp: string | number) => number;
  timeZone: string;
};

export const colors = {
  demand: "#1f3c88",
  behindMeterPV: "#fdee1eff",
  behindMeterBattery: "#ffa569ff",
  generation: "#d35400",
  import: "#c2e2ffff",
  export: "#6776ffff",
  batteryChargeFromPV: "#4ecdc4ff",
  batteryChargeFromGrid: "#b469ffff",
  batteryDischargeGrid: "#2fffafff",
  batteryAuxDemand: "#6e4f4cff",
  batteryFinalCharge: "#777777",
  exportRaw: "#ff6b6bff",
  exportMetered: "#ff6600",
  networkImport: "#2e86c1",
  forecastGeneration: "#e67e22",
  forecastGenerationP90: "#a85600",
  forecastDemand: "#5b7fbf",
  weatherActualsInrange: "#2ecc71",
  performanceRatio: "#9b59b6",
  expectedGenPeriods: "#f5c842",
  unavailableGeneration: "#e74c3c",
  healthEvents: "#fd7e14",
};
